export const defaultChatSettings={autoOpen:false,autoOpenDelaySeconds:5,autoOpenFrequency:'session' as 'session'|'page',askVisitorName:false,messageSound:true};
